// src/utils/cropImage.js
// export const getCroppedImg = (imageSrc, pixelCrop) => {
//   return new Promise((resolve, reject) => {
//     const image = new Image();
//     image.src = imageSrc;
//     image.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = pixelCrop.width;
//       canvas.height = pixelCrop.height;
//       const ctx = canvas.getContext("2d");

//       ctx.drawImage(
//         image,
//         pixelCrop.x,
//         pixelCrop.y,
//         pixelCrop.width,
//         pixelCrop.height,
//         0,
//         0,
//         pixelCrop.width,
//         pixelCrop.height
//       );

//       canvas.toBlob((blob) => {
//         const fileUrl = URL.createObjectURL(blob);
//         resolve(fileUrl);
//       }, "image/jpeg");
//     };
//     image.onerror = (err) => reject(err);
//   });
// };


// src/utils/cropImage.js
// export const getCroppedImg = (imageSrc, pixelCrop) => {
//   return new Promise((resolve, reject) => {
//     const image = new Image();
//     image.src = imageSrc;
//     image.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = pixelCrop.width;
//       canvas.height = pixelCrop.height;
//       const ctx = canvas.getContext("2d");

//       ctx.drawImage(
//         image,
//         pixelCrop.x,
//         pixelCrop.y,
//         pixelCrop.width,
//         pixelCrop.height,
//         0,
//         0,
//         pixelCrop.width,
//         pixelCrop.height
//       );

//       // ✅ CHANGE THIS: Return Base64 string instead of blob URL
//       const base64String = canvas.toDataURL("image/jpeg");
//       resolve(base64String);
      
//       // ❌ REMOVE THIS: Don't create blob URL
//       // canvas.toBlob((blob) => {
//       //   const fileUrl = URL.createObjectURL(blob);
//       //   resolve(fileUrl);
//       // }, "image/jpeg");
//     };
//     image.onerror = (err) => reject(err);
//   });
// };

// src/utils/cropImage.js
// export const getCroppedImg = (imageSrc, pixelCrop) => {
//   return new Promise((resolve, reject) => {
//     const image = new Image();
//     image.src = imageSrc;
//     image.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = pixelCrop.width;
//       canvas.height = pixelCrop.height;
//       const ctx = canvas.getContext("2d");

//       ctx.drawImage(
//         image,
//         pixelCrop.x,
//         pixelCrop.y,
//         pixelCrop.width,
//         pixelCrop.height,
//         0,
//         0,
//         pixelCrop.width,
//         pixelCrop.height
//       );

//       // ✅ THIS IS THE KEY LINE - must return Base64
//       const base64String = canvas.toDataURL("image/jpeg");
//       console.log('Generated Base64:', base64String.substring(0, 100) + '...');
//       resolve(base64String);
//     };
//     image.onerror = (err) => reject(err);
//   });
// };

// src/utils/cropImage.js
export const getCroppedImg = (imageSrc, pixelCrop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous'; // Add this for CORS
    image.src = imageSrc;
    
    image.onload = () => {
      console.log('Original image loaded, creating canvas...');
      
      const canvas = document.createElement("canvas");
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext("2d");

      // Set white background for transparent images
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );

      try {
        // ✅ Force JPEG format with quality
        const base64String = canvas.toDataURL("image/jpeg", 0.92);
        console.log('Base64 generated, first 100 chars:', base64String.substring(0, 100));
        console.log('Base64 starts with data:image?', base64String.startsWith('data:image/jpeg'));
        
        resolve(base64String);
      } catch (error) {
        console.error('Error generating base64:', error);
        reject(error);
      }
    };
    
    image.onerror = (err) => {
      console.error('Error loading image:', err);
      reject(err);
    };
  });
};